import config from './../config';

const baseUrl = config.get('WOLFCONNECT_API_URL');
const WolfConnectRoutes = Object.freeze({
    WOLFCONNECT_GET_EXTRANET: baseUrl + 'wolfconnect/clients/v1/'
});
export default WolfConnectRoutes;